module.exports = function(res) {
  return res.json();
};
